export default function GrainOverlay() {
  return <div className="tacc-grain" aria-hidden="true" />;
}
